module.exports = __webpack_public_path__ + "static/media/10_materiali-OSA_20160622.69b7a799.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2016/10_materiali-OSA_20160622.pdf
// module id = 173
// module chunks = 0